import { actionTypes as FirebaseActions } from 'react-redux-firebase';

import { DEFAULT_CREATE_SEND_SHIPMENT_INFO_STATE } from '../../../constants/createSendShipmentInfo';
import { ICreateSendShipmentInfoPatch, ICreateSendShipmentInfoState } from '../../../types/createSendShipmentInfo';
import * as AuthActions from '../../actions/auth';
import * as ShipmentInfoActions from '../actions/shipmentInfo';

export const initialState: ICreateSendShipmentInfoState = DEFAULT_CREATE_SEND_SHIPMENT_INFO_STATE;

const reducer = (state: ICreateSendShipmentInfoState = initialState, action: any): ICreateSendShipmentInfoState => {
  switch (action.type) {
    case AuthActions.ADMIN_ROLE_CHANGED:
    case AuthActions.CHANGE_ORGANIZATION_SUCCESS:
    case FirebaseActions.LOGOUT:
    case ShipmentInfoActions.RESET_CS_SHIPMENT_INFO: {
      return initialState;
    }
    case ShipmentInfoActions.PATCH_CS_SHIPMENT_INFO: {
      const payload: ICreateSendShipmentInfoPatch = action.payload;
      return {
        form: payload.form ? { ...state.form, ...payload.form } : state.form,
        selectedAddressId:
          payload.selectedAddressId !== undefined ? payload.selectedAddressId : state.selectedAddressId,
        addressApplied: payload.addressApplied !== undefined ? payload.addressApplied : state.addressApplied,
      };
    }
    default:
      return state;
  }
};

export default reducer;
